import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { InstitutionType } from '@app/models/institution';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CSVDataService } from '@app/export/CSVDataService';
import { TSVDataService } from '@app/export/TSVDataService';
import { MemberService } from '@app/services/member.service';
import { SortService } from '@app/components/sorting/SortService';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { PdfService } from '@app/services/pdf/pdf.service';

import { ClaimsService } from '@app/services/claims/claims.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { LoaderService } from '@app/services/loader/loader.service';
import { MenuItem } from 'primeng/api';
//import { identifierModuleUrl } from '@angular/compiler';
import { Sort } from '@angular/material/sort';

interface InstitutionResult {
  id: number;
  institutionType: string;
  institutionNumber: number;
  organizationNumber: string;
  visitingAddress: {
    careOf: string;
    street: string;
    zipCode: string;
    city: string;
    country: string;
  }
  email: string;
  phone: string;
  swish: string;
  phoneMobile: string;
  website: string;
  bankAccount1: string;
  bankAccount2: string;
  paymentAddress: {
    street: string;
    zipCode: string;
    city: string;
    country: string;
    careOf: string;
  }
  installationInterval: string;
  districtInstitutionid: number;
  districtShortName: string;
  startDate: string;
  endDate: string;
  shortName: string;
  name: string;
  seat: string;
  visitingCity: string;
  memberCount: number;
  meetingInterval: string;
  checked: boolean;
}

interface District {
  id: number;
  shortName: string;
  name: string;
  seat: string;
}

@Component({
  selector: 'app-institutionreport',
  templateUrl: './institutionreport.component.html',
  styleUrls: ['./institutionreport.component.css']
})
export class InstitutionreportComponent implements OnInit, OnDestroy {
  institutionform;
  
  items: MenuItem[];
  test;
  selectyearform;
  

  subscriptions: Subscription[] = [];
  institutiontypes: InstitutionType[] = [];

  matrikellist: any[] = [];
  districtlist: District[] = [];
  institutionresult: InstitutionResult[] = [];
  selectedinstitutions: InstitutionResult[] = [];
  institutionfeelist;
  yearfromlist: Number[] = [];
  yeartolist: Number[] = [];
  selectyears = false;
  showlillamatrikeln = false;
  showfeelist = false;
  showLabelsAsHtml = false;
  isSomekindofAdmin = false;
  isSysAdmin = false;
  isClerk = false;
  usualmember = false;
  permissions: string[] = [];


  viewtinymatrix = false;
  viewmemfee = false;
  lastnumber;
  // tslint:disable-next-line:max-line-length
  constructor(private fb: FormBuilder, private permissionsService: PermissionsService, private institutionService: InstitutionsService, private loaderService: LoaderService, private claimsService: ClaimsService, private router: Router, private pdfservice: PdfService, private datePipe: DatePipe, private memberService: MemberService, private memberOfficeService: MemberofficeService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
  }

  ngOnInit() {
    this.selectyearform = this.fb.group({
      yearFrom: ['', Validators.required],
      yearTo: ['', Validators.required]
    });
    
    this.institutionform = this.fb.group({
      institutionTypeId: ['', ''],
      institutionNumber: ['', ''],
      institutionName: ['', ''],
      visitingCity: ['', ''],
      seat: ['', ''],
      districtId: ['', ''],
      startDateFrom: ['', ''],
      startDateTo: ['', ''],
      endDateFrom: ['', ''],
      endDateTo: ['', ''],
      meetingInterval: ['', '']
    });
    this.setItems();
    this.getInstitutionTypes();
    this.getAllDistricts();
    this.getFromYears(null);

    this.isSomekindofAdmin = this.claimsService.isSomekindofAdmin();
    this.isClerk = this.claimsService.isClerk();
    this.isSysAdmin = this.claimsService.isSysAdmin();
    this.usualmember = !this.isSomekindofAdmin;

    this.permissionsService.permissions.subscribe(response => {
      if (response) {
        this.permissions = response;

        const idx = this.permissions.findIndex((item => {
          return item === 'VIEW_TINY_MATRIX';
        }) as any);
        this.viewtinymatrix = idx !== -1;
      }

      const idxfee = this.permissions.findIndex((item => {
        return item === 'VIEW_MEMFEE';
      }) as any);
      this.viewmemfee = idxfee !== -1;

    });

  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        //visible: !this.viewtinymatrix,
        visible: true,
        command: () => this.exportToCSV()
      }, {
        label: 'Etiketter (csv)',
        icon: 'fa fa-id-card',
        visible: this.selectedinstitutions.length > 0,
        command: () => this.createLabels()
      }, {
        label: 'Etiketter',
        icon: 'fa fa-id-card',
        command: () => this.createLabelsHTML(),
        visible: this.selectedinstitutions.length > 0
      }, {
        label: 'Lilla Matrikeln',
        icon: 'fa fa-address-card-o',
        visible: this.selectedinstitutions.length > 0 && this.viewtinymatrix && !this.showlillamatrikeln,
        command: () => this.createLillaMatrikeln()
      }, {
        label: 'Pdf',
        icon: 'fa fa-file-pdf',
        visible: this.showlillamatrikeln,
        command: () => this.captureScreen()
      }, {
        label: 'Avbryt',
        icon: 'fa fa-times',
        visible: this.showlillamatrikeln,
        command: () => this.closeLittleMatrix2()
      }];
  }

  createLabels() {

    let idlista: any[] = [];
    this.selectedinstitutions.forEach(x => {
      idlista.push(x.id);
    });
    this.memberService.GetMemberInfoFromInstitutionIds(idlista).subscribe(x => {
      if (x) {
        let institutionlista: any[] = [];
        x.forEach(i => {
          const data = {
            institutionName: i.institutionShortName + ' ' + i.institutionName,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry
          };
          institutionlista.push(data);
        });


        const firstrow = 'Institution;Gatuadress;Postnummer;Ort;Land';
        const filnamn = 'OF_Etikettdata_institutioner';
        CSVDataService.exportToCsv(filnamn + '.csv', institutionlista, firstrow);
      }
    });
  }

  

  createLabelsHTML() {
    
    //this.showLabelsAsHtml = true;
    // Här ska anrop ske till InstitutionService.GetInstitutionLabelMatrix(int instid)
    /*const params = {
      InstitutionIds: this.selectedinstitutions
    };*/
    const ids = [];

    ids.push(...this.selectedinstitutions.map(inst => inst.id));
  
   /* const params = {
      Format: 'A4',
      ExportOptions: 'pdf',
      InstitutionIds: [266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 252, 264, 251, 236, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 237, 249, 238, 239, 240, 241, 242, 243]
    };*/
    const params = {
      Format: 'A4',
      ExportOptions: 'pdf',
      InstitutionIds: ids
    };
    
    this.institutionService.CreateInstitutionLabelMatrixReportForDownload(params).subscribe(response => {
      if (response) {
        
        let linkSource = 'data:application/pdf;base64,' + response.fileContents;
        const downloadLink = document.createElement("a");
        const fileName = 'Institutioner_Etiketter';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });

  }


  closeLittleMatrix2() {
    this.closeLittleMatrix();
    this.selectedinstitutions = [];
    this.viewtinymatrix = false;
    this.setItems();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  clear() {
    this.institutionform?.reset();
    this.institutionresult = [];
  }



  onSubmit() { }

  getInstitutionTypes() {
    this.subscriptions.push(this.institutionService.getInstitutionTypes().subscribe(data => {
      this.institutiontypes = data;
    }));
  }

  getAllDistricts() {
    this.memberService.getAllDistricts(0).subscribe(response => {
      this.districtlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
    });
  }

  checkuncheckAll(element) {
    let value = false;
    element.checked ? value = true : value = false;
    for (const m of this.institutionresult) {
      m.checked = value;
      this.add(m, element);
    }
  }

  search() {
    this.institutionService.GetInstitutionReportAsync(this.institutionform.value).subscribe(resp => {
      this.institutionresult = resp;
      let lastinstid;
      this.institutionresult.forEach(ir => {
        ir['checked'] = false;

        if (ir.id !== lastinstid) {
          ir['checkbox'] = true;
          lastinstid = ir.id;
        }
      });

    });
  }

  sortData(sort: Sort) {
    const data = this.institutionresult.slice();
    if (!sort.active || sort.direction === '') {
      this.institutionresult = data;
      return;
    }



    this.institutionresult = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        // case 'no': return this.compare(a.id, b.id, isAsc);
        case 'districtInstitutionid': return this.compare(a.districtInstitutionid, b.districtInstitutionid, isAsc);
        // case 'districtShortName': return this.compare(a.districtShortName, b.districtShortName, isAsc);
        case 'districtShortName': return SortService.cmpStringsWithNumbers(a.districtShortName, b.districtShortName, isAsc);
        case 'startDate': return this.compare(a.startDate, b.startDate, isAsc);
        case 'endDate': return this.compare(a.endDate, b.endDate, isAsc);
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'memberCount': return this.compare(a.memberCount, b.memberCount, isAsc);
        case 'name': return this.compare(a.name, b.name, isAsc);
        case 'seat': return this.compare(a.seat, b.seat, isAsc);
        // case 'shortName': return this.compare(a.shortName, b.shortName, isAsc);
        case 'shortName': return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  viewInstitution(institutionid: number) {
    this.router.navigate(['/institutions/id/', institutionid], { queryParams: { viewmode: true } });
  }

  back() {
    this.selectyears = false;
    this.showfeelist = false;
    this.institutionfeelist = [];
    this.selectedinstitutions = [];
  }

  exportToCSV() {
    // delete this.institutionresult['memberCount'];



    // tslint:disable-next-line:max-line-length
    // const firstrow = 'Id;Institution (kort);Institution;Besöksort;Säte;DistriktId;Distrikt (kort);Mötesintervall;Startdatum;Slutdatum;Antal';
    const firstrow = 'Institutios-ID;Institutionstyp;Nummer;Organisationsnummer;Institutionsnamn;Besöksadress C/O;Besöksadress Gata;Besöksadress Postnummer;Besöksadress Ort;Besöksadress Land;Epost;Telefon;Swish;Mobil;Hemsida;Instituerad;Avvecklad;Postgiro;Bankgiro;Postadress C/O;Postadress Postnummer;Postadress Postort;Postadress Land;Installation;Mötesdagar;Säte;Distrikt;Antal medlemmar idag';
    const datum = this.datePipe.transform(new Date(), 'yyMMdd');
    const filnamn = 'Institutioner_' + datum;

    let data = [];

    this.institutionresult.forEach(r => {

      r.startDate = this.datePipe.transform(r.startDate, 'yyyy-MM-dd');
      if (r.endDate.startsWith('9999')) {
        r.endDate = null;
      } else {
        r.endDate = this.datePipe.transform(r.endDate, 'yyyy-MM-dd');
      }

      const row = {
        id: r.id,
        institutionType: r.institutionType,
        institutionNumber: r.institutionNumber,
        organizationNumber: r.organizationNumber,
        name: r.name,
        visitingAddress_careOf: r.visitingAddress?.careOf,
        visitingAddress_street: r.visitingAddress?.street,
        visitingAddress_zipCode: r.visitingAddress?.zipCode,
        visitingAddress_city: r.visitingAddress?.city,
        visitingAddress_country: r.visitingAddress?.country,
        email: r.email,
        phone: r.phone ? r.phone + String.fromCharCode(8203) : '',
        swish: r.swish ? r.swish + String.fromCharCode(8203) : '',
        phoneMobile: r.phoneMobile ? r.phoneMobile + String.fromCharCode(8203) : '',
        website: r.website,
        startDate: r.startDate,
        endDate: r.endDate,
        bankAccount1: r.bankAccount1,
        bankAccount2: r.bankAccount2,
        paymentAddress_street: r.paymentAddress?.street,
        paymentAddress_zipCode: r.paymentAddress?.zipCode,
        paymentAddress_city: r.paymentAddress?.city,
        paymentAddress_country: r.paymentAddress?.country,
        paymentAddress_careOf: r.paymentAddress?.careOf,
        installationInterval: r.installationInterval,
        meetingInterval: r.meetingInterval,
        seat: r.seat,
        districtShortName: r.districtShortName,
        memberCount: r.memberCount
      }

      data.push(row);
    }

    );
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);

  }

  add(selectedmember, element) {

    if (element.checked) {

      this.selectedinstitutions.push(selectedmember);
      this.viewtinymatrix = true;
      //     this.addItem(selectedmember, element);
    } else {
      // this.removeFromArray(selectedmember.id);
      this.removeFromArray(selectedmember.id);
      if (this.selectedinstitutions.length <= 0) {
        this.viewtinymatrix = false;
      }
    }
    this.setItems();
  }

  removeFromArray(institutionid: number) {
    const idx = this.selectedinstitutions.findIndex((item => item.id === institutionid) as any);
    this.selectedinstitutions.splice(idx, 1);
  }

  chooseYear() {
    // alert('Inaktiverad just nu innan behörighetskontroll är pålagd. Funktionalitet är på plats.');
    this.selectyears = true;
  }

  closeLittleMatrix() {
    this.showlillamatrikeln = false;
  }

  generateFeeReport() {
    const fromyear = Number(this.selectyearform.get('yearFrom').value);
    const toyear = Number(this.selectyearform.get('yearTo').value);
    const years = [];
    const institutionlist = [];
    for (let y = fromyear; y <= toyear; y++) {
      years.push(y);
    }
    for (const i of this.selectedinstitutions) {
      institutionlist.push((i.id) as any);
    }

    const feereportdata = {
      years: years,
      institutionIds: institutionlist
    };
    this.test = feereportdata;

    this.institutionService.GetFeesPerInstitutionAndYear(feereportdata).subscribe(response => {
      this.institutionfeelist = response;
      this.showfeelist = true;
    });

  }

  clearYearForm() {
    this.selectyearform.reset();
  }

  getFromYears(from: any) {
    this.yearfromlist = [];
    const toyear = new Date().getFullYear();
    if (!from) {
      from = 1883;
    }

    for (let y = toyear; y > from; y--) {
      this.yearfromlist.push(y);
    }
  }

  getToYears(from: any) {
    this.yeartolist = [];
    const toyear = new Date().getFullYear();
    if (!from) {
      from = 1883;
    }

    for (let y = toyear; y > from; y--) {
      this.yeartolist.push(y);
    }
  }

  yearFromSelected(evt: any) {

    const fromyear = evt.target.options[evt.target.selectedIndex].text;
    this.getToYears(fromyear);
  }

  createLillaMatrikeln() {
    const institutions: Number[] = [];
    for (const i of this.selectedinstitutions) {
      institutions.push(i.id);
    }

    this.memberOfficeService.GetMemberOfficeListing(institutions).subscribe(response => {

      this.matrikellist = response;
      this.showlillamatrikeln = true;
      this.setItems();
    });

  }

  sameInstitutionNumber(institutionnumber: number) {
    if (this.lastnumber === institutionnumber) {
      return false;
    } else {
      this.lastnumber = institutionnumber;
      return true;
    }
  }

  captureScreen() {

    const data = document.getElementById('contentToConvert');
    this.pdfservice.captureScreen(data, 'p', null);

    // this.testing(data);
  }

  testing(data) {
    const element = data;
    const opt = {
      margin: 1,
      filename: 'myfile.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };



    // New Promise-based usage:
    // html2pdf().set(opt).from(element).save();

  }
}
